import React from 'react';
import { colors, fonts } from '../brand';

export default function Disclaimer() {
  return (
    <div style={styles.bar}>
      <p style={styles.safety}>
        If you are in immediate danger, please call <strong>911</strong>. &nbsp;·&nbsp; National DV Hotline: <strong>1.800.799.SAFE (7233)</strong> or text <strong>START</strong> to <strong>88788</strong>
      </p>
      <p style={styles.text}>
        <strong style={styles.strong}>DISCLAIMER:</strong> All information provided by Elephants Answering, including all materials and information on this website, is general and educational only. IT IS NOT INTENDED TO BE NOR SHOULD YOU CONSIDER IT TO BE PROFESSIONAL OR LEGAL ADVICE IN ANY MANNER. Every divorce is different — please consult a licensed attorney in your state and of your choice for support specific to your situation and before making any substantive determinations.
      </p>
    </div>
  );
}

const styles = {
  bar: {
    backgroundColor: '#F7F3EF',
    borderTop: `2px solid ${colors.peach}`,
    padding: '14px 32px',
    textAlign: 'center',
  },
  safety: {
    fontFamily: fonts.body,
    fontSize: '12px',
    color: colors.navy,
    lineHeight: '1.8',
    maxWidth: '860px',
    margin: '0 auto 10px',
    letterSpacing: '0.2px',
  },
  text: {
    fontFamily: fonts.body,
    fontSize: '11px',
    color: colors.textMedium,
    lineHeight: '1.8',
    maxWidth: '860px',
    margin: '0 auto',
    letterSpacing: '0.2px',
  },
  strong: {
    color: colors.navy,
    fontWeight: '600',
  },
};
